import IModelComponent from '@components/FormFlow/Interfaces/FormflowComponents/IModelComponent';
import { LocalStorageKeys } from '@containers/App';
import IPagination from '@interfaces/IPagination';
import { ITarget } from '@interfaces/ITargets';
import TargetService from '@services/TargetService';
import { Select } from 'antd';
import React from 'react';

const Option = Select.Option;
interface IQRCODETaskComponentStateType {
  instructionTitle: string;
  targets: ITarget[];
  offset?: string,
  targetId: string,
  description?: string;


};


const _targetService: TargetService = new TargetService();
export default class QRCodeTaskComponent extends React.Component<IModelComponent, IQRCODETaskComponentStateType> {
  private idUnit: string = '';

  constructor(props: IModelComponent) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this.state = {
        targetId: this.props ? this.props.targetId : '',
        targets: [],
    };
  }

  componentDidMount = async () => {
    this.getTargets(true);
  }

  async getTargets(reset: boolean) {

    if (reset) {
      this.setState({
        offset: undefined
      });
    }
    try {
      const response: IPagination<ITarget> = await _targetService.paging({
        unit: this.idUnit,
        to: undefined,
        from: undefined,
        limit: 100,
        offset: this.state.offset
      });
      this.setState({ targets: response.items, offset: response.offset });
    } catch (e) {
      console.error(e)
    }
  }


  getOptionsTargets = () => {
    let options: JSX.Element[] = []
    for (const items of this.state.targets) {
      options.push(
        <Option key={items.id} value={items.id} >{items.name}</Option>
      )
    }
    return options;
  }
  
  
  handleTargetSelectChange = async (evt: any) => {    
    this.setState({ targetId: evt })
    const items = this.state.targets.find((e: any) => e.id === this.state.targetId)
    this.setState({ urlTarget: items ? items.url : '' })
}
  render() {
    console.log("this.state.targetId ", this.state.targetId)
    return (
      <div>
        <p>A</p>
      </div>
    );
  }
}



